/**
 * Client mount harness. Every site's main.tsx ended with the same dance:
 * server-rendered markup (root has children) → hydrate; empty root (dev / a
 * standalone build) → fresh render. Fonts and globals.css stay in the site's
 * main.tsx (they are per-design); the site imports them, then calls mountClient.
 *
 *   import './globals.css'
 *   import App from './App'
 *   import { mountClient } from '@gjl/site-kit'
 *   mountClient(App)
 */
import { StrictMode, type ComponentType } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

export function mountClient(App: ComponentType, rootId = 'root'): void {
  const el = document.getElementById(rootId)
  if (!el) throw new Error(`mountClient: #${rootId} element not found`)

  const tree = (
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  )

  if (el.hasChildNodes()) {
    hydrateRoot(el, tree)
  } else {
    createRoot(el).render(tree)
  }
}
